import {gql} from '@apollo/client';

export default gql`
  mutation noPlacements($input: NoPlacementsInput!) {
    noPlacements(input: $input) {
      success
    }
  }
`;
